export default [
  {
    label: "เมนูรายการ",
    items: [
      {
        label: "ทะเบียน",
        icon: "pi pi-fw pi-folder-open",
        category: "registration",
        items: [
          {
            label: "ทะเบียนฟาร์ม (ผท.3)",
            icon: "pi pi-fw pi-circle",
            to: "/agency/farm",
            menuId: 1,
          },
          {
            label: "ทะเบียนสัตว์ (ผท.1)",
            icon: "pi pi-fw pi-circle",
            to: "/agency/creature",
            menuId: 3,
          },
          {
            label: "สืบค้นทะเบียนน้ำเชื้อ",
            icon: "pi pi-fw pi-circle",
            to: "/agency/sperm",
            menuId: 4,
          },
          {
            label: "สืบค้นทะเบียนตัวอ่อน",
            icon: "pi pi-fw pi-circle",
            to: "/agency/embryo",
            menuId: 5,
          },
          {
            label: "ทะเบียนเกษตรกร",
            icon: "pi pi-fw pi-circle",
            to: "/agency/farmer",
            menuId: 2,
          },
          {
            label: "ทะเบียนบุคลากร",
            icon: "pi pi-fw pi-circle",
            to: "/personnel",
            menuId: 25,
          },
          {
            label: "จัดการผู้ใช้งาน (สำหรับแอดมิน)",
            icon: "pi pi-fw pi-circle",
            to: "/setting/manage_users",
            menuId: 27,
          },
        ],
      },
      {
        label: "เจ้าหน้าที่ผสมเทียม",
        icon: "pi pi-fw pi-user",
        category: "activity",
        items: [
          {
            label: "ข้อมูลฟาร์ม",
            icon: "pi pi-fw pi-circle",
            to: "/activity/farm_info",
            menuId: 11,
          },
          {
            label: "ข้อมูลสัตว์",
            icon: "pi pi-fw pi-circle",
            to: "/activity/creature_info",
            menuId: 12,
          },
          {
            label: "แจ้งเตือนรายวัน",
            icon: "pi pi-fw pi-circle",
            to: "/activity/daily-alert",
            menuId: 13,
          },

          {
            label: "การจัดเก็บข้อมูลการขุน/อาหาร",
            icon: "pi pi-fw pi-circle",
            to: "/activity/food",
            menuId: 14,
          },
          // {
          //   label: "การคัดจำหน่ายแบบหลายตัว",
          //   icon: "pi pi-fw pi-circle",
          //   to: "/activity/distribution",
          // },
          {
            label: "สุขภาพ",
            icon: "pi pi-fw pi-circle",
            items: [
              {
                label: "ฉีดวัคซีน",
                icon: "pi pi-minus",
                to: "/activity/vaccine",
                menuId: 15,
              },
              {
                label: "ตรวจโรค",
                icon: "pi pi-minus",
                to: "/activity/diagnose",
                menuId: 16,
              },
              {
                label: "การรักษา",
                icon: "pi pi-minus",
                to: "/activity/treatment",
                menuId: 26,
              },
              {
                label: "ถ่ายพยาธิ",
                icon: "pi pi-minus",
                to: "/activity/deworm",
                menuId: 17,
              },
            ],
          },
          {
            label: "บันทึกตรวจระบบสืบพันธุ์ (ใหม่)",
            icon: "pi pi-fw pi-circle",
            to: "/activity/reproductive",
            menuId: 99,
          },
          {
            label: "คัดจำหน่ายรายฝูง",
            icon: "pi pi-fw pi-circle",
            to: "/activity/distributions",
            menuId: 28,
          },
        ],
      },
      {
        label: "ย้ายฝากตัวอ่อน",
        icon: "pi pi-fw pi-sort-alt",
        category: "embryo_transfer",
        items: [
          {
            label: "กำหนดโปรแกรมสำหรับแม่ตัวให้/ตัวรับ",
            icon: "pi pi-fw pi-circle",
            to: "/embryo/setting",
            menuId: 6,
          },
          {
            label: "เตรียมแม่ตัวให้ (Donor ET)",
            icon: "pi pi-fw pi-circle",
            to: "/embryo/donor",
            menuId: 7,
          },
          {
            label: "สืบค้นทะเบียนตัวอ่อน",
            icon: "pi pi-fw pi-circle",
            to: "/agency/embryo",
            menuId: 5,
          },
          // {
          //   label: "บันทึกเก็บตัวอ่อน",
          //   icon: "pi pi-fw pi-circle",
          //   to: "/embryo/embryo",
          //   menuId: 8,
          // },
          {
            label: "เตรียมแม่ตัวรับ (Recipient)",
            icon: "pi pi-fw pi-circle",
            to: "/embryo/recipient",
            menuId: 9,
          },

          {
            label: "ย้ายฝากตัวอ่อน",
            icon: "pi pi-fw pi-circle",
            to: "/embryo/transfer",
            menuId: 10,
          },
          {
            label: "รายงานระบบย้ายฝากตัวอ่อน",
            icon: "pi pi-fw pi-print",
            to: "/report/embryo-transfer",
            menuId: 102,
          },
        ],
      },
      {
        label: "ระบบโครงการ",
        icon: "pi pi-fw pi-book",
        category: "tropical_holstein",
        items: [
          {
            label: "ติดตามโครงการ",
            icon: "pi pi-fw pi-circle",
            to: "/project/detail",
            menuId: 29,
          },
          {
            label: "บันทึกการเจริญเติบโต โคเนื้อ",
            icon: "pi pi-fw pi-circle",
            to: "/project/thaiblack",
            menuId: 30,
          },
          {
            label: "บันทึกการเจริญเติบโต แพะ",
            icon: "pi pi-fw pi-circle",
            to: "/project/redgoat",
            menuId: 31,
          },
          {
            label: "จัดการโครงการ",
            icon: "pi pi-fw pi-cog",
            to: "/project/manage",
            menuId: 70,
          },
        ],
      },
      {
        label: "รายงาน",
        icon: "pi pi-fw pi-print",
        category: "report",
        items: [
          {
            label: "ด้านทะเบียนประวัติ",
            icon: "pi pi-fw pi-circle",
            items: [
              {
                label: "รายงานประชากรสัตว์",
                icon: "pi pi-minus",
                to: "/report/pregnancy4",
              },

              {
                label: "รายงานด้านทะเบียนฟาร์ม",
                icon: "pi pi-minus",
                to: "/report/FarmReport",
              },
              {
                label: "รายงานสรุปทะเบียนโค",
                icon: "pi pi-minus",
                to: "/report/Total_Animal",
              },
              // {
              //   label: "สรุปโคแยกตามสายพันธุ์",
              //   icon: "pi pi-minus",
              //   to: "/report/animalbreed",
              // },
              {
                label: "ทะเบียนประวัติเพศเมีย",
                icon: "pi pi-minus",
                to: "/report/animalbreed",
              },
              {
                label: "ประวัติแม่พันธุ์รายตัว",
                icon: "pi pi-minus",
                to: "/report/history_registration",
              },
            ],
          },
          {
            label: "ด้านน้ําเชื้อ ตัวอ่อน",
            icon: "pi pi-fw pi-circle",
            items: [
              {
                label: "รายงานการใช้น้ำเชื้อ",
                icon: "pi pi-minus",
                to: "/report/semen",
              },
              {
                label: "ทะเบียนประวัติพ่อพันธุ์",
                icon: "pi pi-minus",
                to: "/report/breeder",
              },
              {
                label: "รายงานการใช้ตัวอ่อน",
                icon: "pi pi-minus",
                to: "/report/embryo",
              },
            ],
          },
          {
            label: "ด้านการผสมเทียม (Workstep)",
            icon: "pi pi-fw pi-circle",
            items: [
              {
                label: "ติดตามการผสมเทียม ผท.6",
                icon: "pi pi-minus",
                to: "/report/aipt6",
              },
              {
                label: "รายงานสัตว์ (สาว) ที่ยังไม่ได้รับการผสม",
                icon: "pi pi-minus",
                to: "/report/young",
              },
              {
                label: "รายงานครบกำหนดตรวจท้อง",
                icon: "pi pi-minus",
                to: "/report/CheckupDue",
              },
              {
                label: "รายงานครบกำหนดคลอด",
                icon: "pi pi-minus",
                to: "/report/mating",
              },
              //   รายงานสรุปจำนวนสัตว์ตั้งท้อง
              {
                label: "รายงานสรุปจำนวนสัตว์ตั้งท้อง",
                icon: "pi pi-minus",
                to: "/report/TotalPreg",
              },
              {
                label: "รายงานครบกำหนดติดตามลูกเกิด",
                icon: "pi pi-minus",
                to: "/report/CheckBirth",
              },
            ],
          },
          {
            label: "ด้านการตรวจระบบสืบพันธุ์",
            icon: "pi pi-fw pi-circle",
            items: [
              {
                label: "รายงานตรวจระบบสืบพันธุ์ (ใหม่)",
                icon: "pi pi-minus",
                to: "/report/reproduce-checkup-form3",
              },
              {
                label: "รายงานแก้ไขปัญหาทางระบบสืบพันธุ์ (ใหม่)",
                icon: "pi pi-minus",
                to: "/report/reproduce-checkup-form4",
              },
              {
                label: "รายงานแก้ไขปัญหาทางระบบสืบพันธุ์ (เดิม)",
                icon: "pi pi-minus",
                to: "/report/reproduce",
              },
            ],
          },

          {
            label: "รายงานผลปฏิบัติการ",
            icon: "pi pi-fw pi-circle",
            items: [
              {
                label: "รายงานสรุปตรวจท้อง",
                icon: "pi pi-minus",
                to: "/report/pregnancy1",
              },
              {
                label: "รายงานสรุปผลติดตามลูกเกิด",
                icon: "pi pi-minus",
                to: "/report/pregnancy3",
              },
              {
                label: "รายงานการปฏิบัติงานเจ้าหน้าที่",
                icon: "pi pi-minus",
                to: "/report/work",
              },
            ],
          },
          {
            label: "รายงานด้านการวิเคราะห์ข้อมูล",
            icon: "pi pi-fw pi-circle",
            items: [
              {
                label: "วิเคราะห์ประสิทธิภาพระบบสืบพันธุ์",
                icon: "pi pi-minus",
                to: "/report/analyze",
              },
            ],
          },
        ],
      },
      {
        label: "ผู้ดูแลระบบ",
        icon: "pi pi-fw pi-cog",
        category: "admin",
        items: [
          {
            label: "ข้อมูลภาพรวม (monitor)",
            icon: "pi pi-fw pi-circle",
            to: "/setting/dashboard",
          },
          {
            label: "จัดการผู้ใช้งาน",
            icon: "pi pi-fw pi-circle",
            to: "/setting/users",
          },
          {
            label: "จัดการกลุ่มผู้ใช้งาน",
            icon: "pi pi-fw pi-circle",
            to: "/setting/group",
          },
          {
            label: "เวลาการเข้าใช้งาน",
            icon: "pi pi-fw pi-circle",
            to: "/setting/loglogin",
          },
          {
            label: "จัดการวงจรชีวิตสัตว์",
            icon: "pi pi-fw pi-circle",
            to: "/activity/creature_info",
          },
          {
            label: "จัดการผู้ใช้งานเกษตรกร",
            icon: "pi pi-fw pi-circle",
            to: "/setting/usersfarmer",
          },
          {
            label: "ข่าวสาร",
            icon: "pi pi-fw pi-circle",
            to: "/setting/news",
          },
          {
            label: "อนุมัติรายการ",
            icon: "pi pi-fw pi-circle",
            items: [
              {
                label: "แจ้งขอทำบัตร",
                icon: "pi pi-minus",
                to: "/requestcard",
              },
            ],
          },
          {
            label: "ทะเบียนหน่วยงาน",
            icon: "pi pi-fw pi-circle",
            to: "/agency",
          },
          {
            label: "โครงการ",
            icon: "pi pi-fw pi-circle",
            items: [
              {
                label: "จัดการโครงการ",
                icon: "pi pi-fw pi-circle",
                to: "/project/all",
              },
              // {
              //     label: "ตรวจสอบโครงการ",
              //     icon: "pi pi-fw pi-circle",
              //     to: "/project/view",
              // },

              // {
              //     label: "ตั้งเป้าหมายโครงการ",
              //     icon: "pi pi-fw pi-circle",
              //     to: "/project/goal",
              // },
            ],
          },

          // ข้อมูลเมนูพื้นฐาน
          {
            label: "ข้อมูลพื้นฐาน",
            icon: "pi pi-fw pi-circle",
            items: [
              {
                label: "ข้อมูลพื้นฐานที่ตั้ง",
                icon: "pi pi-minus",
                items: [
                  {
                    label: "ประเทศ",
                    icon: "pi pi-minus",
                    to: "/user_center/country",
                  },
                  {
                    label: "ภูมิภาค",
                    icon: "pi pi-minus",
                    to: "/user_center/region",
                  },
                  {
                    label: "จังหวัด",
                    icon: "pi pi-minus",
                    to: "/user_center/province",
                  },
                  {
                    label: "อำเภอ",
                    icon: "pi pi-minus",
                    to: "/user_center/amphur",
                  },
                  {
                    label: "ตำบล",
                    icon: "pi pi-minus",
                    to: "/user_center/tumbol",
                  },
                ],
              },
              {
                label: "ข้อมูลพื้นฐานบุคคล",
                icon: "pi pi-minus",
                items: [
                  {
                    label: "เพศ",
                    icon: "pi pi-minus",
                    to: "/user_center/gender",
                  },
                  {
                    label: "คำนำหน้าชื่อ",
                    icon: "pi pi-minus",
                    to: "/user_center/title",
                  },
                  {
                    label: "สถานภาพการสมรส",
                    icon: "pi pi-minus",
                    to: "/user_center/marriedstatus",
                  },
                  {
                    label: "ประเภทบุคลากร",
                    icon: "pi pi-minus",
                    to: "/user_center/positiontype",
                  },

                  {
                    label: "ระดับการศึกษา",
                    icon: "pi pi-minus",
                    to: "/user_center/education",
                  },

                  {
                    label: "อาชีพ",
                    icon: "pi pi-minus",
                    to: "/user_center/occupation",
                  },
                  // {
                  //   label: "ทำงานด้าน",
                  //   icon: "pi pi-minus",
                  //   to: "/user_center/duty",
                  // },
                  {
                    label: "สาขาวิชา",
                    icon: "pi pi-minus",
                    to: "/user_center/academy_major",
                  },
                ],
              },

              {
                label: "ข้อมูลหน่วยงาน",
                icon: "pi pi-minus",
                items: [
                  {
                    label: "เขตปศุสัตว์",
                    icon: "pi pi-minus",
                    to: "/user_center/zone",
                  },
                  {
                    label: "ศูนย์วิจัย",
                    icon: "pi pi-minus",
                    to: "/user_center/ai_zone",
                  },
                  {
                    label: "ประเภทหน่วยงาน",
                    icon: "pi pi-minus",
                    to: "/user_center/organization_type",
                  },
                  {
                    label: "ตำแหน่งงาน",
                    icon: "pi pi-minus",
                    to: "/user_center/position",
                  },
                ],
              },

              {
                label: "ข้อมูลประจำตัวสัตว์",
                icon: "pi pi-minus",
                items: [
                  {
                    label: "เพศสัตว์",
                    icon: "pi pi-minus",
                    to: "/user_center/animalsex",
                  },

                  {
                    label: "ประเภทสัตว์",
                    icon: "pi pi-minus",
                    to: "/user_center/animalgenre",
                  },

                  {
                    label: "ชนิดสัตว์หลัก",
                    icon: "pi pi-minus",
                    to: "/user_center/animalgrouptype",
                  },

                  {
                    label: "สถานะสัตว์",
                    icon: "pi pi-minus",
                    to: "/user_center/cow_status",
                  },

                  {
                    label: "ชนิดสัตว์",
                    icon: "pi pi-minus",
                    to: "/user_center/animal_type",
                  },

                  {
                    label: "ประเภทสายพันธ์",
                    icon: "pi pi-minus",
                    to: "/user_center/breed_type",
                  },
                ],
              },
              {
                label: "ข้อมูลฟาร์ม",
                icon: "pi pi-minus",
                items: [
                  // {
                  //   label: "ประเภทฟาร์ม",
                  //   icon: "pi pi-minus",
                  //   to: "/user_center/farm_type",
                  // },

                  {
                    label: "สถานะฟาร์ม",
                    icon: "pi pi-minus",
                    to: "/user_center/farmstatus",
                  },
                ],
              },
              {
                label: "ข้อมูลกิจกรรม",
                icon: "pi pi-minus",
                items: [
                  // {
                  //   label: "ฮอร์โมน",
                  //   icon: "pi pi-minus",
                  //   to: "/user_center/hormone",
                  // },

                  {
                    label: "คะแนนร่างกาย",
                    icon: "pi pi-minus",
                    to: "/user_center/bcs",
                  },

                  {
                    label: "วิธีการย้ายฝาก",
                    icon: "pi pi-minus",
                    to: "/user_center/transfermethod",
                  },

                  {
                    label: "ลักษณะการแท้ง",
                    icon: "pi pi-minus",
                    to: "/user_center/abortresult",
                  },
                  {
                    label: "วิธีการตรวจการตั้งท้อง",
                    icon: "pi pi-minus",
                    to: "/user_center/pregnancycheckmethod",
                  },

                  {
                    label: "สถานะตรวจการตั้งท้อง",
                    icon: "pi pi-minus",
                    to: "/user_center/pregnancycheckstatus",
                  },
                  {
                    label: "สถานะตัวอ่อน",
                    icon: "pi pi-minus",
                    to: "/user_center/embryo_stages",
                  },
                  {
                    label: "วิธีการช่วยคลอด",
                    icon: "pi pi-minus",
                    to: "/user_center/givebirthhelp",
                  },
                  {
                    label: "แหล่งที่มาของสัตว์",
                    icon: "pi pi-minus",
                    to: "/user_center/cow_source",
                  },
                  {
                    label: "ปืนสอดลึก",
                    icon: "pi pi-minus",
                    to: "/user_center/gundepth",
                  },
                  {
                    label: "การเป็นสัดของแพะ",
                    icon: "pi pi-minus",
                    to: "/user_center/goatestralactivity",
                  },
                  {
                    label: "โปรแกรมกิจกรรม",
                    icon: "pi pi-minus",
                    to: "/user_center/presetactivity",
                  },
                  {
                    label: "สาเหตุการคัดจำหน่าย",
                    icon: "pi pi-minus",
                    to: "/user_center/distributions",
                  },
                ],
              },
              {
                label: "ข้อมูลการขุนอาหาร",
                icon: "pi pi-minus",
                items: [
                  {
                    label: "อาหารหยาบ",
                    icon: "pi pi-minus",
                    to: "/user_center/roughages",
                  },

                  {
                    label: "อาหารข้น",
                    icon: "pi pi-minus",
                    to: "/user_center/concentrate",
                  },
                ],
              },
              {
                label: "ข้อมูลการตรวจสุขภาพ",
                icon: "pi pi-minus",
                items: [
                  {
                    label: "โรค",
                    icon: "pi pi-minus",
                    to: "/user_center/disease",
                  },

                  {
                    label: "วิธีการตรวจโรค",
                    icon: "pi pi-minus",
                    to: "/user_center/diseasemethod",
                  },
                  {
                    label: "ผลการตรวจโรค",
                    icon: "pi pi-minus",
                    to: "/user_center/diseaseresult",
                  },
                  {
                    label: "วัตถุประสงค์การฉีดวัคซีน",
                    icon: "pi pi-minus",
                    to: "/user_center/vaccineobjective",
                  },
                  {
                    label: "วัคซีน",
                    icon: "pi pi-minus",
                    to: "/user_center/vaccine",
                  },
                  {
                    label: "ยาถ่ายพยาธิ",
                    icon: "pi pi-minus",
                    to: "/user_center/dewormmedicine",
                  },
                ],
              },
              {
                label: "ข้อมูลการตรวจระบบสืบพันธุ์",
                icon: "pi pi-minus",
                items: [
                  {
                    label: "อาการเป็นสัด",
                    icon: "pi pi-minus",
                    to: "/user_center/heattype",
                  },

                  {
                    label: "วงรอบการเป็ดสัด",
                    icon: "pi pi-minus",
                    to: "/user_center/heatcircle",
                  },
                  {
                    label: "ปัญหารังไข่",
                    icon: "pi pi-minus",
                    to: "/user_center/ovarysymptom",
                  },
                  {
                    label: "ปัญหามดลูก/ช่องคลอด",
                    icon: "pi pi-minus",
                    to: "/user_center/vaginasymptom",
                  },
                  {
                    label: "ปัญหาอื่นๆ",
                    icon: "pi pi-minus",
                    to: "/user_center/othersymptom",
                  },
                  {
                    label: "สาเหตุโน้มนำด้านตัวสัตว์",
                    icon: "pi pi-minus",
                    to: "/user_center/causeanimal",
                  },
                  {
                    label: "สาเหตุโน้มนำด้านสิ่งแวดล้อม",
                    icon: "pi pi-minus",
                    to: "/user_center/causeenvironment",
                  },
                  {
                    label: "สาเหตุโน้มนำการเลี้ยงและการจัดการ",
                    icon: "pi pi-minus",
                    to: "/user_center/causefeeder",
                  },
                  {
                    label: "สาเหตุโน้มนำด้านสุขภาพ",
                    icon: "pi pi-minus",
                    to: "/user_center/causehealth",
                  },
                  {
                    label: "ฮอร์โมน",
                    icon: "pi pi-minus",
                    to: "/user_center/curehormone",
                  },
                  {
                    label: "ยาปฏิชีวนะ",
                    icon: "pi pi-minus",
                    to: "/user_center/cureantibiotic",
                  },
                  {
                    label: "ยาและวิตามิน",
                    icon: "pi pi-minus",
                    to: "/user_center/curevitamin",
                  },
                  {
                    label: "คำแนะนำแก้ปัญหาระบบสืบพันธุ์",
                    icon: "pi pi-minus",
                    to: "/user_center/reproducesuggestion",
                  },
                  {
                    label: "ยารักษาและฮอร์โมน (ตรวจสืบพันธุ์ใหม่)",
                    icon: "pi pi-minus",
                    to: "/user_center/reproductivedrug",
                  },
                ],
              },
              // {
              //   label: "หน่วยงาน",
              //   icon: "pi pi-minus",
              //   to: "/user_center/organization",
              // },
              // {
              //   label: "สถานภาพการผลิต",
              //   icon: "pi pi-minus",
              //   to: "/user_center/production_status",
              // },
              // {
              //   label: "สถานะการคัดจำหน่าย",
              //   icon: "pi pi-minus",
              //   to: "/user_center/culling_status",
              // },
              // {
              //   label: "สาเหตุการคัดจำหน่าย",
              //   icon: "pi pi-minus",
              //   to: "/user_center/culling_cause",
              // },
            ],
          },
        ],
      },
    ],
  },
];
